import { atom } from 'jotai';
import { createStore, } from 'jotai/vanilla';
export type Environment = {
  [key : string]: any | string;
};

export const environmentsAtom = atom<any>(null);
export const secureAtom = atom<string | null>(null);

export const store: any = createStore();
